const TOP10_GRANT_LABELS = {
  PSG: "Productivity Solutions Grant (PSG)",
  EDG: "Enterprise Development Grant (EDG)",
  MRA: "Market Readiness Assistance (MRA)",
  SFEC: "SkillsFuture Enterprise Credit (SFEC)",
  SFEG: "Skills Framework Enhancement Grant (SFEG)",
  EIS: "Enterprise Innovation Scheme (EIS)",
  DIGITAL: "SMEs Go Digital",
  FINTECH: "MAS FinTech Grant",
  STARTUP_FOUNDER: "Startup SG Founder",
  EEG: "Energy Efficiency Grant (EEG)",
  BIZADAPT: "Business Adaptation Grant (BizAdapt)",
  SRG: "Sustainability Reporting Grant (SRG)",
  BIF: "Business Improvement Fund (BIF)",
  LEF: "Leisure Events Fund (LEF)",
  ESF: "Experience Step-Up Fund (ESF)",
  ACT: "Agri-Food Cluster Transformation Fund (ACT)",
  BETC: "Built Environment Technology Grant (BETC)",
  EHVCG: "Electric Heavy Vehicle Charger Grant (EHVCG)",
  ECCG: "Electric Vehicle Common Charger Grant (ECCG)",
  GIA: "Global Innovation Alliance (GIA+)",
  GRT_OA: "Global Ready Talent - Overseas Allowance (GRT-OA)",
  MCF_IA: "Maritime Cluster Fund - Industry Attachment (MCF-IA)",
  MCF_MA: "Maritime Cluster Fund - Management Associates (MCF-MA)",
  MCF_OA: "Maritime Cluster Fund - Overseas Attachment (MCF-OA)",
  WDG_JR_PLUS: "Workforce Development Grant - Job Redesign+ (WDG JR+)",
  SCSG: "Lorry Crane Stability Control System Grant (SCSG)",
};

const SYNONYM_MAP = Object.entries(TOP10_GRANT_LABELS).reduce(
  (acc, [code, label]) => {
    acc[code] = label;
    acc[label] = label;
    return acc;
  },
  {}
);

const NORMALIZED_SPECIAL_LABELS = {
  none: "None previously received",
  "none previously received": "None previously received",
  others: "Others (grants not listed above)",
  "others (grants not listed above)": "Others (grants not listed above)",
};

/**
 * Convert stored grant history value (code or label) to user-friendly label.
 *
 * @param {string} value
 * @returns {string}
 */
export function formatGrantHistoryItem(value) {
  if (!value) return "Not specified";

  const normalized = String(value).trim();
  const lower = normalized.toLowerCase();

  if (NORMALIZED_SPECIAL_LABELS[lower]) {
    return NORMALIZED_SPECIAL_LABELS[lower];
  }

  const upper = normalized.toUpperCase();
  if (SYNONYM_MAP[upper]) {
    return SYNONYM_MAP[upper];
  }

  if (SYNONYM_MAP[normalized]) {
    return SYNONYM_MAP[normalized];
  }

  return normalized;
}

/**
 * Format an array of grant history values for display.
 *
 * @param {string[]} priorApps
 * @returns {string[]}
 */
export function formatGrantHistoryList(priorApps = []) {
  return priorApps.map(formatGrantHistoryItem);
}


